import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { useSettings } from '@/context/SettingsContext';
import { createAppTheme } from './theme';

const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { themeMode, language } = useSettings();

  const theme = useMemo(
    () => createAppTheme(themeMode, language),
    [themeMode, language]
  );

  const cacheRtl = useMemo(
    () =>
      createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
      }),
    []
  );

  const cacheLtr = useMemo(
    () =>
      createCache({
        key: 'muiltr',
      }),
    []
  );

  const cache = language === 'ar' ? cacheRtl : cacheLtr;

  return (
    <CacheProvider value={cache}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </CacheProvider>
  );
};

export default AppThemeProvider;
